import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { ThemeProvider } from './context/ThemeContext';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

const msalConfig = {
  auth: {
    clientId: '7e9ba977-33b0-4e9c-ae75-55f65da317bd',
    authority: 'https://login.microsoftonline.com/e7d2bb21-f43c-4773-9f21-554692ceb28d',
    // MSAL v5 returns every sign-in, sign-out and silent renewal through the redirect bridge page
    redirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI,
    postLogoutRedirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then(() => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <ThemeProvider>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </ThemeProvider>
      </React.StrictMode>
    );
  });
});
